export default __webpack_public_path__ + "static/media/down-arrow.bb4836d1.svg";